module.exports = __webpack_public_path__ + "img/c5.fb9ece9b.jpg";